import React from "react"
import { tsPropertySignature } from "@babel/types"

function PortfolioDetails(props){
    return(<div>
        <div className="modal fade" id= {props.details.id} tabindex="-1" role="dialog" aria-labelledby="portfolio-popup" aria-hidden="true">
	<div className="modal-dialog window-popup portfolio-popup" role="document">
		<div className="modal-content">		
			<div className=" contact-area modal-body">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
          			<span aria-hidden="true">&times;</span>
        		</button>
				<div className="portfolio-popup-form  ">				
					<div className="tab-content">
						<div className="tab-pane active " id="home1" role="tabpanel" data-mh="log-tab">							
							<div className="comment-form ">
								<div className="designation" >
								<h4>{props.details.title}</h4>
								</div>
								<div className="row align-items-center justify-content-between">
									<div className="col-sm-12 col-lg-6">
									{props.details.media}
									</div>									
									<div className="col-sm-12 col-lg-6">
                                    {props.details.content}
										
									</div>
								</div>
							</div>									
						</div>
					</div>
				</div>						
			</div>
		</div>
	</div>
</div>
    </div>

    )
}

export default PortfolioDetails